import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Delete, HideSource, Visibility } from '@mui/icons-material';
import { IconButton, ListItem, ListItemText, Tooltip, Typography } from '@mui/material';

export default function ColumnOcultaMenu(props) {
    const {kanban, confs, showColuna} = props;

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    function handleMostrarColuna(col){
        console.log( col );
        if( showColuna)showColuna(col);
    }
    function getNome(col){
        const item = kanban.colunas.find( c => c.id === col.idCol)
        if( item ) return item.nome;
        return '';
    }
    return (
        <div>
            <Button
                startIcon={<HideSource />}
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                size='small'
            >
                Colunas
            </Button>
            <Menu
                id="basic-menu"
                sx={{
                    '& .MuiPaper-root': {
                        borderRadius: 6,
                        minWidth: 180,
                        color: 'rgb(55, 65, 81)',
                        boxShadow:
                        'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
                        '& .MuiMenu-list': {
                            padding: '4px 0',
                          },
                    }
                }}          
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    list: {
                        'aria-labelledby': 'basic-button',
                    },
                }}
            >
                {confs && confs.map( (row, id) =>
                    <ListItem key={id} alignItems="center"
                    // disableGutters
                    secondaryAction={
                        <Tooltip title="Apresentar coluna">
                            <IconButton aria-label="comment" onClick={() =>handleMostrarColuna(row) }>
                                <Visibility />
                            </IconButton>
                        </Tooltip>
                    }
                >
                    <ListItemText
                        primary={ getNome(row)}
                    />
                </ListItem>
                )}
                
                
            </Menu>
        </div>
    )
}